import { gql } from '@apollo/client';

export const SET_CORREIOS_CREDENTIALS = gql`
  mutation SetCorreiosCredentials($credentials: CorreiosCredentialsInput!) {
    setCorreiosCredentials(credentials: $credentials) {
      __typename
      ... on SetCorreiosCredentialsSuccess {
        code
        credentials {
          correiosId
          correiosPassword
          correiosAdministrativeCode
          correiosContract
          correiosServiceCode
          correiosPostageCard
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
